// FlowLanes.jsx — per-flow real-time lanes (Social / SEO / Email) driven by the
// worker's live queue counts (overview.queues). Each lane is a step diagram
// with in-flight + failed counts, so every flow — not just social — is visible.

import React from "react";

const LANES = [
  { key: "social", label: "Social posting", color: "#0F62FE", stages: [
    { label: "Ideas", q: "idea-generation" }, { label: "Posts", q: "post-generation" },
    { label: "Images", q: "image-generation" }, { label: "Watermark", q: "media-watermark" },
    { label: "Perfectionist", q: "perfectionist" }, { label: "Approval", q: "email-approval" },
    { label: "Posting", q: "social-posting" },
  ] },
  { key: "seo", label: "SEO articles", color: "#8a3ffc", stages: [
    { label: "Keywords", q: "seo-keyword-research" }, { label: "Briefs", q: "seo-brief" },
    { label: "Articles", q: "seo-article" }, { label: "Publish", q: "seo-publish" },
  ] },
  { key: "email", label: "Email sequences", color: "#198038", stages: [
    { label: "Generate", q: "email-sequence-generate" }, { label: "Steps", q: "email-sequence-step" },
    { label: "Send", q: "email-send" }, { label: "Templates", q: "email-template-generate" },
  ] },
];

function findQ(queues, name) {
  if (!Array.isArray(queues)) return null;
  return queues.find((x) => x && typeof x.name === "string" && x.name.indexOf(name) !== -1) || null;
}

export default function FlowLanes({ queues }) {
  return (
    <div style={{ marginTop: 18 }}>
      <style>{`
        .lane{margin-bottom:14px}
        .lane-title{font-size:12px;font-weight:700;margin-bottom:6px}
        .lane-row{display:flex;align-items:stretch;gap:0;flex-wrap:wrap}
        .lane-stage{min-width:96px;border:1px solid #e5e7eb;border-radius:8px;padding:8px 10px;text-align:center;background:#fff}
        .lane-stage .n{font-size:18px;font-weight:700}
        .lane-stage .l{font-size:11px;color:#666}
        .lane-stage .f{font-size:10px;color:#a71d2a}
        .lane-arrow{display:flex;align-items:center;color:#c4c9d0;padding:0 4px}
      `}</style>
      {LANES.map((lane) => (
        <div className="lane" key={lane.key}>
          <div className="lane-title" style={{ color: lane.color }}>{lane.label}</div>
          <div className="lane-row">
            {lane.stages.map((st, i) => {
              const q = findQ(queues, st.q);
              const inflight = q ? (q.waiting || 0) + (q.active || 0) + (q.delayed || 0) : 0;
              return (
                <React.Fragment key={st.q}>
                  <div className="lane-stage" style={{ borderColor: inflight ? lane.color : "#e5e7eb" }}>
                    <div className="n" style={{ color: inflight ? lane.color : "#9ca3af" }}>{inflight}</div>
                    <div className="l">{st.label}</div>
                    {q && q.failed > 0 && <div className="f">⚠ {q.failed}</div>}
                  </div>
                  {i < lane.stages.length - 1 && <div className="lane-arrow">→</div>}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      ))}
      <div style={{ fontSize: 11, color: "#999" }}>Live in-flight (queued + active) per stage across every brand. Failed jobs auto-clean every 10 min.</div>
    </div>
  );
}
